import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
// 如果你同时使用 Vuex 和 Pinia，请确保它们不会冲突
// 通常建议只使用一个状态管理库
// import store from './store' // 考虑移除这行
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/file-name-editor.css'
import { installUniverHexColorInputPatch } from './utils/univerHexColorInputPatch'
import { installUniverFontFamilyDisplayPatch } from './utils/univerFontFamilyDisplayPatch'
import { installUniverUndoRedoPatch } from './utils/univerUndoRedoPatch'

installUniverHexColorInputPatch()
installUniverFontFamilyDisplayPatch()
installUniverUndoRedoPatch()

const app = createApp(App)
const pinia = createPinia()

// 取消注释并确保 Pinia 正确初始化
app.use(pinia)
app.use(router)
app.use(ElementPlus)

// 如果你确实需要同时使用 Vuex 和 Pinia（不推荐），取消下面这行
// app.use(store)

app.mount('#app')
